<button mat-stroked-button [matBadge]="approvalCount" [matBadgeHidden]="approvalCount === 0" [matMenuTriggerFor]="ahMenu" type="button">
	Approvals
</button>
<mat-menu #ahMenu="matMenu" xPosition="before">
	<div class="header-container" (click)="$event.stopPropagation()">
		<div class="caption-title">
			Approval History
		</div>
		<button mat-icon-button aria-label="Close Approval History" class="pull-right" (click)="closeMenu()">
			<mat-icon>cancel</mat-icon>
		</button>
	</div>
	<div class="body-container" (click)="$event.stopPropagation()">
		<div class="table-container">
			<mat-table class="table" [dataSource]="dataSource">
				<ng-container matColumnDef="EffectiveDT">
					<mat-header-cell *matHeaderCellDef>
						<span class="column-text">Approval Date</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.EffectiveDT | date: 'MM/dd/yyyy hh:mm a' }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="UserName">
					<mat-header-cell *matHeaderCellDef>
						<span class="column-text">User Name</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.UserName }}
					</mat-cell>
				</ng-container>
				<ng-container matColumnDef="ApprovalLevel">
					<mat-header-cell *matHeaderCellDef>
						<span class="column-text">Approval Level</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.ApprovalLevel }}
					</mat-cell>
				</ng-container>
				<mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
			</mat-table>
			<shared-no-data-available *ngIf="dataSource.data.length === 0"></shared-no-data-available>
		</div>
	</div>
</mat-menu>
